module.exports = "<div data-component=\"confirmation-cards\" *ngIf=\"active\">\n\t<app-list-confirmation [list]=\"confirmList\" justList=\"true\"></app-list-confirmation>\n\t<app-signature [disabled]=\"disabled\" (onSetForm)=\"onSetSignatureForm($event)\" [submited]=\"submited\"></app-signature>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/cards/confirmation/confirmation.component.html
// module id = ../../../../../src/app/master/cards/confirmation/confirmation.component.html
// module chunks = main